import { React, useState } from "react";
import { ChapterWrapper } from "../Education.styled";
import PropTypes from "prop-types";

function BookChapter({ data }) {
	// eslint-disable-next-line no-unused-vars
	const [displayVideo, setdisplayVideo] = useState(false);
	return (
		<ChapterWrapper>
			<>
				<img
					src={data?.coverPhoto || "/images/placeholder_img.jpg"}
					alt='content thumbnail'
				/>
				<main>
					<div>
                    {data?.chapter ?  <p className='chapter_text'>chapter {data?.chapter}</p> : <p className='chapter_text'>Single chapter</p> }
						<button type='button'>
							<a
								className='side_btn'
								href={data?.link}
								target='_blank'
								rel='noreferrer'
							>
								Download
							</a>
						</button>
					</div>

					<div>
						<p className='content_title'>{data?.name || "--"}</p>
					</div>
				</main>
			</>
		</ChapterWrapper>
	);
}

BookChapter.propTypes = {
	data: PropTypes.object,
};

export default BookChapter;
